const React = require("react");
const PT = require("prop-types");
const createReactClass = require("create-react-class");
const AssetsUtil = require("../../core/util/AssetsUtil");
const styles = require("./styles/ToDoClip.css");

module.exports = createReactClass({
	displayName: "ToDoClip",

	propTypes: {
		className: PT.string.isRequired,
		showNote: PT.bool,
		direction: PT.string,
	},

	render: function() {
		const {showNote, className} = this.props;
		const toDoImg = AssetsUtil.getHWIcon(true, showNote === false);

		return (
			<div className={className}>
				<img className={styles.image} src={toDoImg} />
			</div>
		);
	},
});
